import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  APP_ZONES,
  BaseCssProperties,
  FieldAttribute,
  ProviderClass,
  UiZoneWidgetConfig,
  WidgetNames,
  baseCssConfigStyle,
  buttonNestedWidgetConfigStyles,
} from '@finxone-platform/shared/sys-config-types';
import { Subject, Subscription, debounceTime, map, takeUntil } from 'rxjs';
import { ConfigService } from '../../../../lib/services/config-service/config-service.service';
import { MetadataService } from '../../../../lib/services/metadata-service/metadata-service.service';
import {
  FormStage,
  MultiPartFormHolderService,
} from '../../../../lib/services/multipart-holder/multipart-form-holder.service';

import { Router } from '@angular/router';
import { PageConfigurationProvider } from '@app/finxone-web-frontend/app/Modules/zones/page-configuration.provider';
import { FormSubmissionService } from '@app/finxone-web-frontend/app/lib/services/form-submission-service/form-submission-service.service';
import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import { removeAsterisk, setCssAttributes } from '@app/finxone-web-frontend/app/lib/utils/utils';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import { Store } from '@ngxs/store';
import { FormActionTypeEnum } from 'libs/shared/enums/form-action.enum';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { StyleServiceService } from '../../../../lib/services/style-service/style-service.service';
import { ZonePageUrlProvider } from '../../../zones/zone-url-provider';
import { FormSubmitter } from '../form-widgets/form-submitter/form-submitter.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmailComponent extends FormSubmitter implements OnInit, OnDestroy {
  @Output() formValuesChange = new EventEmitter<any>();
  @Input() formActionStateData: { [key: string]: string };
  @Input() dynamicZone = false;
  @Input() fieldAttributesEmail: FieldAttribute[];
  public zone = 'onboarding';
  public widgetConfig: UiZoneWidgetConfig;
  public userProfileData: any;
  @Input() showErrorPopup: (args: boolean) => void;
  @AutoDestroy override destroy$: Subject<void> = new Subject<void>();
  public emailForm: FormGroup;
  public isStepComplete = false;
  public isError = false;
  public isAnyFieldRequired = false;
  public isShowErrorMsg = false;
  public errorMsg = '';
  public email = '';
  public isFieldDisabled = false;
  public colorTextAlignStyle: baseCssConfigStyle;
  public colorStyle: baseCssConfigStyle;
  public borderStyle: baseCssConfigStyle;
  private emailVerified = false;

  public showConfirmBtn = false;
  public showWaitingIcon = false;
  public showCheckedIcon = false;
  private verificationPopupResponseSubscriptionEmail: Subscription;
  private nextPageUrl: string;
  public emailFormValue = { email: '' };
  public isEmailVerificationEnabled: boolean;

  public isEmailShowSuccessIcon = false;
  public isEmailShowErrorIcon = false;
  public textInputFontStyle: baseCssConfigStyle;
  public textInputBackgroundColor: baseCssConfigStyle;
  public combinedContentAndBorderStyles: baseCssConfigStyle;
  private isValueChanged = true;
  public isOldEmail: boolean;
  public inputStyle: baseCssConfigStyle;
  public inputBaseStyle: baseCssConfigStyle;
  public inputInactiveStyle: baseCssConfigStyle;
  public currentInputStyle: baseCssConfigStyle;
  private formActionData: Record<string, any> | null;
  public fieldAttributes: FieldAttribute[];
  private formActionStateId: FormActionTypeEnum;
  private lastVerifiedEmail: string;
  public verifyButtonStyle: baseCssConfigStyle;
  public verifyButtonTextContent: string;
  public isWorkflow: boolean;
  public globalStylingClass = '';
  public isAllowedGlobalStyling = false;

  constructor(
    private configService: ConfigService,
    private metaService: MetadataService,
    private formHolderService: MultiPartFormHolderService,
    public dataIn: ProviderClass<any>,
    public ngxSmartModalService: NgxSmartModalService,
    private urlZoneInput: ZonePageUrlProvider,
    protected override store: Store,
    private formSubmissionService: FormSubmissionService,
    public pageConfig: PageConfigurationProvider,
    private styleService: StyleServiceService,
    private _router: Router,
    private alertHandlerService: AlertHandlerService,
  ) {
    super(store);
    this.zone = this.urlZoneInput.zoneUrlInput;
    if (this.dataIn != undefined) {
      this.widgetConfig = this.dataIn.widgetConfig;
      this.fieldAttributes = this.widgetConfig?.attributes['field_attributes'];
      this.attri = this.dataIn.attri;
    }
  }

  ngOnInit(): void {
    this.isAnyFieldRequired = false;
    if (this.dynamicZone && this.fieldAttributesEmail) {
      this.fieldAttributes = this.fieldAttributesEmail;
    }
    this.userProfileData = this.store.selectSnapshot(ProfileState.getProfile);
    this.isFieldDisabled = false;
    if (this.dataIn != undefined && this.dataIn != null) {
      this.widgetConfig = this.dataIn.widgetConfig;
      this.attri = this.dataIn.attri;
    }
    this.onCheckEmailVerificationFlag();
    this.lastVerifiedEmail = this.userProfileData.email;
    let formGroupExtension = {};
    let isVerified = false;
    let email = '';
    if (this.zone !== formatNameAsUrl(APP_ZONES.ONBOARDING)) {
      isVerified = this.formActionData?.['isEmailVerified'] ?? this.userProfileData.emailVerified;
      email = this.formActionData?.['email'] ?? this.userProfileData.email;
    }
    if (this.dynamicZone) {
      email = this.formActionStateData?.['email'] || '';
      isVerified = this.formActionStateData?.['isEmailVerified'] === 'true' || false;
    }
    formGroupExtension = this.getEmailVerificationField(isVerified);
    const formStage = new FormStage({
      position: 0,
      name: WidgetNames.EMAIL_WIDGET,
      route: '/onboard-individual/register',
      form: new FormGroup({
        email: new FormControl(email ?? '', [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,30}$'),
        ]),
        ...formGroupExtension,
      }),
    });
    this.formSubmissionService.addCurrentPageFormGroups(formStage.form);
    const stage = this.formHolderService.config.getStage(WidgetNames.EMAIL_WIDGET);
    if (!stage) {
      this.formHolderService.config.addStage(formStage);
    }
    this.getFormStateIdFromZone();
    this.buildForm();
    this.subscribeDataFromState(this.formActionStateId);
    this.checkEmailSuccessErrorIconFlag();
    this.setCssAttributes();
    this.getGlobalStyling();
  }

  private getGlobalStyling() {
    if (
      this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStylingClass'] &&
      this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStyling']
    ) {
      this.globalStylingClass =
        this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStylingClass'] ??
        '';
      this.isAllowedGlobalStyling =
        this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStyling'] ?? false;
    }
  }

  private subscribeDataFromState(id?: string) {
    if (!this.dynamicZone) {
      this.subscribeToFormAction(id)
        .pipe(
          takeUntil(this.destroy$),
          map((response) => {
            if (response?.formData?.['email']) {
              this.formActionData = response.formData;
              if (response?.formData?.['isEmailVerified']) {
                this.lastVerifiedEmail = response.formData['email'];
              }
              if (this.emailForm?.get('email')) this.patchFormValues(response.formData);
            }
            if (response?.nextPageUrl) this.nextPageUrl = response.nextPageUrl;
            if (response?.type === 'submitStep') {
              this.checkEmailVerificationValidation();
            }

            if (response?.type === 'submitStep' && this.emailForm.valid) {
              this.onSubmit();
            }
          }),
        )
        .subscribe();
    } else {
      this.formActionData = this.formActionStateData;
      this.patchFormValues(this.formActionStateData);
    }
  }
  private getEmailVerificationField(isVerified: boolean) {
    return {
      isEmailVerified: new FormControl(this.isEmailVerificationEnabled ? isVerified : true, [
        Validators.requiredTrue,
      ]),
    };
  }
  private setCssAttributes() {
    const {
      contentStyle,
      colorTextAlignFontStyle,
      colorStyle,
      borderStyle,
      textInputFontStyle,
      textInputBackgroundColor,
    } = setCssAttributes(this.styleService, this.configService, this.attri);

    this.contentStyle = contentStyle;
    this.colorStyle = colorStyle;
    this.colorTextAlignStyle = {
      ...this.configService.getSpecificBaseCssStyle(this.attri, [
        BaseCssProperties.TEXT_BOLD,
        BaseCssProperties.TEXT_ITALIC,
        BaseCssProperties.TEXT_UNDERLINE,
        BaseCssProperties.FONT_SIZE,
        BaseCssProperties.TEXT_FONT_STYLE,
        BaseCssProperties.TEXTALIGN,
        BaseCssProperties.COLOR,
      ]),
    };
    this.borderStyle = borderStyle;
    this.combinedContentAndBorderStyles = {
      ...contentStyle,
      ...borderStyle,
    };
    this.textInputFontStyle = textInputFontStyle;
    this.textInputBackgroundColor = textInputBackgroundColor;
    const { baseStyle, activeStyle, inactiveStyle } = this.configService.getInputFieldCssStyles(
      this.attri.widgetProperties,
    );

    this.inputStyle = baseStyle;
    this.inputBaseStyle = activeStyle;
    this.inputInactiveStyle = inactiveStyle;
    this.currentInputStyle = {
      ...this.inputInactiveStyle,
      ...this.inputBaseStyle,
    };
    this.isWorkflow = this.configService.getActiveConfigType().isWorkflow;
    if (this.dataIn.widgetConfig?.nestedWidgets?.['verifyButton']) {
      this.verifyButtonStyle = this.configService.getSpecificBaseCssStyle(
        this.getNestedWidgetConfig(this.dataIn, 'verifyButton'),
        buttonNestedWidgetConfigStyles,
      );
      this.verifyButtonTextContent = this.getNestedWidgetConfig(
        this.dataIn,
        'verifyButton',
      )?.widgetProperties?.textContent;
    } else {
      this.verifyButtonStyle = {};
      this.verifyButtonTextContent = 'Verify';
    }
  }
  private checkEmailSuccessErrorIconFlag() {
    if (this.dataIn && this.widgetConfig) {
      const showSuccessErrorIcon = this.isShowAndErorIcon(this.widgetConfig.attributes['elementsConfig']);
      this.isEmailShowErrorIcon = showSuccessErrorIcon.isShowErrorIcon;
      this.isEmailShowSuccessIcon = showSuccessErrorIcon.isShowSuccessIcon;
    }
  }

  public onCheckEmailVerificationFlag() {
    if (this.dataIn && this.widgetConfig) {
      const elementsConfig = this.widgetConfig.attributes['elementsConfig'];

      const verificationOtpField = elementsConfig?.find((item) => item.field_name === 'verificationViaOTP');

      if (verificationOtpField) {
        this.isEmailVerificationEnabled = verificationOtpField.show;
      }
    }
  }

  public updateCurrentStyles(event: boolean) {
    if (!event) {
      this.currentInputStyle = {
        ...this.inputInactiveStyle,
        ...this.inputBaseStyle,
      };
    } else {
      this.currentInputStyle = {
        ...this.inputBaseStyle,
        ...this.inputStyle,
      };
    }
  }

  ngOnDestroy(): void {
    if (this.verificationPopupResponseSubscriptionEmail) {
      this.verificationPopupResponseSubscriptionEmail.unsubscribe();
    }
  }

  private buildForm() {
    const stage = this.formHolderService.config.getStage(WidgetNames.EMAIL_WIDGET);
    this.emailForm = stage?.getForm();
    this.emailForm.valueChanges
      .pipe(
        debounceTime(500),
        takeUntil(this.destroy$),
        map((formValues) => {
          if (!this.dynamicZone) this.performZoneSpecificActions(formValues);
          if (this.emailForm.valid || this.isValueChanged) {
            this.formValuesChange.emit(formValues);
          }
          this.isValueChanged = false;
        }),
      )
      .subscribe();
  }
  private performZoneSpecificActions(formValues: Record<string, string>) {
    switch (this.zone) {
      case formatNameAsUrl(APP_ZONES.ONBOARDING):
        this.performOnboardingZoneActions();
        break;
      case formatNameAsUrl(APP_ZONES.VERIFICATION):
        this.performKycZoneActions(formValues);
        break;
      case formatNameAsUrl(APP_ZONES.PROFILE):
        this.performProfileZoneActions(formValues);
        break;
      // Do not add any more zone specific actions.
      default:
        this.performDefaultEmailActions();
        break;
    }
  }

  private performDefaultEmailActions() {
    if (this.emailForm.valid || this.isValueChanged) {
      this.formSubmissionService.storeFormData(this.emailForm.value);
      this.isValueChanged = false;
    }
  }

  private performOnboardingZoneActions() {
    if (this.emailForm.valid && this.isValueChanged) {
      this.formSubmissionService.storeFormData(this.emailForm.value);
      this.isValueChanged = false;
      if (this.emailForm.get('isEmailVerified')?.invalid && this.emailForm.get('email')?.touched) {
        this.showConfirmBtn = true;
        this.isStepComplete = false;
        this.isError = true;
      }
    }
  }

  private performKycZoneActions(formValues: Record<string, string>) {
    const emailPrevValue = this.formActionData?.['email'] ?? this.userProfileData?.email;
    if (this.emailForm.valid && this.isValueChanged) {
      if (formValues['email'] !== emailPrevValue) {
        this.emailForm.get('isEmailVerified')?.patchValue(false);
        this.isOldEmail = false;
      }
      this.formSubmissionService.storeFormData(this.emailForm.value, FormActionTypeEnum.KYC_DETAILS);
      this.isValueChanged = false;
    }
  }

  private performProfileZoneActions(formValues: Record<string, string>) {
    const emailPrevValue = this.formActionData?.['email'] ?? this.userProfileData?.email;
    if (this.emailForm.valid && this.isValueChanged) {
      if (formValues['email'] !== emailPrevValue) {
        this.emailForm.get('isEmailVerified')?.patchValue(false);
        this.isOldEmail = false;
      }
      this.formSubmissionService.storeFormData(this.emailForm.value, FormActionTypeEnum.EDIT_PROFILE_DETAILS);
      this.isValueChanged = false;
    }
    if (this.emailForm.get('isEmailVerified')?.invalid) {
      this.showConfirmBtn = true;
    }
  }

  public valueChangesTrigger() {
    this.isValueChanged = true;
    if (this.emailForm.get('email')?.value === this.lastVerifiedEmail) {
      this.isOldEmail = true;
      this.emailForm.get('isEmailVerified')?.patchValue(true);
      this.formSubmissionService.storeFormData(this.emailForm.value, this.formActionStateId);
      this.showConfirmBtn = false;
      return;
    }

    if (this.isEmailVerificationEnabled) {
      this.emailForm.get('isEmailVerified')?.patchValue(false);
      const formValues = this.emailForm.value;
      this.isOldEmail = false;
      this.isStepComplete = false;
      // show error
      this.isError = true;
      this.emailForm.setErrors({ invalid: true });
      if (this.formActionStateId) {
        this.formSubmissionService.storeFormData(this.emailForm.value, this.formActionStateId);
      } else {
        this.formSubmissionService.submitIndividualForm(formValues, this.nextPageUrl).then((success) => {
          if (success) {
          }
        });
      }
    } else {
      this.emailForm.patchValue({ isEmailVerified: true });
      this.isStepComplete = true;
      this.isError = false;
    }
  }
  private patchFormValues(formData: Record<string, string>) {
    const formIndex = this.formSubmissionService.currentPageFormGroups?.findIndex((item) =>
      item.get('email'),
    );
    this.formSubmissionService.updateCurrentPageFormGroups(formIndex, this.emailForm);
    this.emailFormValue.email = formData?.['email'];
    this.email = this.emailFormValue.email;
    this.emailForm.get('email')?.setValue(this.email);
    this.isStepComplete = true;
    this.isError = false;
    this.emailVerified = formData?.['isEmailVerified'] as unknown as boolean;
    this.emailForm.get('isEmailVerified')?.setValue(formData?.['isEmailVerified']);
    if (this.isEmailVerificationEnabled && !this.emailVerified) {
      this.showConfirmBtn = true;
      this.isStepComplete = false;
    }
  }

  checkEmailVerificationValidation() {
    if (this.isEmailVerificationEnabled && !this.emailVerified && this.emailForm.get('email')?.valid) {
      this.showConfirmBtn = true;
      this.isStepComplete = false;
      this.isAnyFieldRequired = true;
      this.isError = true;
      this.errorMsg = 'Email needs validation before proceeding to the next step.';
      this.showErrorAlert(this.errorMsg);
    }
  }

  private showErrorAlert(message: string) {
    this.alertHandlerService.showAlertFn('error', message);
  }

  public onSubmit() {
    if (this.emailForm.valid) {
      const formValues = this.emailForm.value;
      this.formSubmissionService.submitIndividualForm(formValues, this.nextPageUrl).then((success) => {
        if (success) {
          this.isStepComplete = true;
          this.isError = false;
          // Form submission was successful, you can handle it here
        } else {
          // Handle submission failure
        }
      });
    } else {
      this.emailForm.markAllAsTouched();
      this.isStepComplete = false;

      this.isError = true;
      this.errorMsg = 'Please enter valid email address';
    }
  }

  private onEmailCheck() {
    const emailValue = this.emailForm.value.email;
    const userProfileEmail = this.userProfileData?.email;
    const isSameValue = emailValue === userProfileEmail;
    if (this.emailForm.value.email != '' && !isSameValue) {
      this.metaService
        .checkEmail(this.emailForm.value.email)
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .pipe(
          takeUntil(this.destroy$),
          map((isVerified: boolean) => {
            if (isVerified == false) {
              this.isStepComplete = false;
              this.isError = true;
              this.errorMsg =
                'There is something might be wrong with email address or Email address already exists';
            } else {
              this.isStepComplete = false;
              this.isError = false;
            }
          }),
        )
        .subscribe();
    } else {
      this.errorMsg = 'Please enter valid email address';
    }
  }
  public showErrorMsg() {
    this.isShowErrorMsg = !this.isShowErrorMsg;
  }

  public onChangeEmailInput(): void {
    this.emailForm.markAllAsTouched();
    if (!this.emailForm.get('email')?.valid) {
      this.isStepComplete = false;
      this.isError = true;
      this.errorMsg = 'Please enter valid email address and confirm using OTP.';
    }
  }

  public verifyEmail() {
    if (this.emailForm.get('email')?.valid) {
      this.showConfirmBtn = false;
      this.showWaitingIcon = true;
      this._router.navigateByUrl(`/zones/${this.zone}/email-confirmation`);
    }
  }

  public verifiedEmailChanged() {
    this.onEmailCheck();
    if (this.isEmailVerificationEnabled) {
      this.showConfirmBtn = true;
    }
    this.showCheckedIcon = false;
    this.showWaitingIcon = false;
    this.emailVerified = false;
    this.metaService.verificationFlag.next({
      fieldName: WidgetNames.EMAIL_WIDGET,
      isVerified: false,
    });
  }
  public emailInputChange() {
    this.isValueChanged = true;
  }

  private getFormStateIdFromZone() {
    switch (this.zone) {
      case formatNameAsUrl(APP_ZONES.VERIFICATION):
        this.formActionStateId = FormActionTypeEnum.KYC_DETAILS;
        break;
      case formatNameAsUrl(APP_ZONES.PROFILE):
        this.formActionStateId = FormActionTypeEnum.EDIT_PROFILE_DETAILS;
        break;
      default:
        return;
    }
  }

  public sanitizeFieldLabel(label: string) {
    return removeAsterisk(label);
  }
}
